import { arrType, datatypes, inputTypes } from "data/globalData";

export const filterColArry = [
	{
		name: "End Date",
		key: "end_date",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.DATE.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		// default_value: "",
	},
	{
		name: "Brand",
		key: "brand",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [
				{ name: "RARE RABBIT", key: "RARE RABBIT" },
				{ name: "RAREISM", key: "RAREISM" },
				{ name: "RAREONES", key: "RAREONES" },
			],
		},
	},
	{
		name: "Division",
		key: "division",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [
				// // { name: allOption, key: allOption },
				{ name: "APPARELS", key: "APPARELS" },
				{ name: "ADDONS", key: "ADDONS" },
				{ name: "FOOT WEAR", key: "FOOT WEAR" },
			],
		},
	},
];
